// CONFIG SETTINGS
//NOTICE: These variables are used by Octopus to dynamically change their values on deployment.
global.REACT_APP_ALERTS_API_URL = "#{REACT_APP_ALERTS_API_URL}";
global.REACT_APP_ENTITY_API_URL = "#{REACT_APP_ENTITY_API_URL}";
global.REACT_APP_OKTA_ID = "#{OktaClientID}";